import { NgClass } from '@angular/common'
import { ChangeDetectionStrategy, Component, input } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'

import { ArticlePurchaseSummaryCardComponent } from './article-purchase-summary-card.component'

@Component({
  selector: 'dhp-article-purchase-account-shell',
  templateUrl: './article-purchase-account-shell.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, TranslatePipe, ArticlePurchaseSummaryCardComponent],
})
export class ArticlePurchaseAccountShellComponent {
  readonly titleKey = input.required<string>()
  readonly descriptionKey = input.required<string | null>()
  readonly eyebrowKey = input<string | null>(null)
  readonly noticeKey = input<string | null>(null)
  readonly showSummary = input(true)
}
